module.exports = __webpack_public_path__ + "images/0bb77846dc091825ce4d3e9e7e1b3555.png";